module.exports = __webpack_public_path__ + "static/media/file-view-jpg.31b4bba4.svg";